export default __webpack_public_path__ + "images/6 АВТОРСКИЙ_.jpg";